module.exports.DLCImageURLs = {
    'Primitive Plus':
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/2/22/Primitive_Plus_Icon.png',
    'P+': 'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/2/22/Primitive_Plus_Icon.png',
    Aberration:
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/b/bb/Aberration_Icon.png',
    'Scorched Earth':
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/8/85/Scorched_Earth_Icon.png',
    Mobile: 'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/b/b3/Logo_Mobile.svg',
    Extinction:
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/a/ad/Extinction_Icon.png',
    Ragnarok:
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/e/ee/Ragnarok_Icon.png',
    'The Center':
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/5/59/The_Center_Icon.png',
    Valguero:
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/e/e7/Valguero_Icon.png',
    Genesis:
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/b/b2/Genesis_Icon.png',
    'Genesis: Part 1':
        'https://static.wikia.nocookie.net/arksurvivalevolved_gamepedia/images/e/e6/Genesis_Part_1_Icon.png/revision/latest/scale-to-width-down/16',
    'Genesis: Part 2':
        'https://static.wikia.nocookie.net/arksurvivalevolved_gamepedia/images/8/8a/Genesis_Part_2_Icon.png/revision/latest/scale-to-width-down/16?cb=20200728194649',
    'Crystal Isles':
        'https://gamepedia.cursecdn.com/arksurvivalevolved_gamepedia/e/e7/Crystal_Isles_Icon.png',
    'Super Structures':
        'https://static.wikia.nocookie.net/arksurvivalevolved_gamepedia/images/d/d6/Mod_Super_Structures_icon.png/revision/latest/scale-to-width-down/16?cb=20200902151247',
    'Structures Plus':
        'https://static.wikia.nocookie.net/arksurvivalevolved_gamepedia/images/4/42/Structures_Plus_Icon.png/revision/latest/scale-to-width-down/16?cb=20190406112632',
};
